import type { ButtonHTMLAttributes } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

/** Use the same styles on semantic links and file-picker labels. */
export function buttonStyles({ variant = 'primary', icon = false, className = '' }: {
  variant?: ButtonVariant;
  icon?: boolean;
  className?: string;
} = {}) {
  return ['ui-button', `ui-button--${variant}`, icon && 'ui-button--icon', className].filter(Boolean).join(' ');
}

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  icon?: boolean;
};

/** Actions default to type="button"; form submissions must opt in explicitly. */
export default function Button({ variant, icon, className, type = 'button', ...props }: ButtonProps) {
  return <button type={type} className={buttonStyles({ variant, icon, className })} {...props} />;
}
